module.exports = __webpack_public_path__ + "img/electricalCircuit.efbd2fe7.jpg";